<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import { Icon } from '@/ui/base';
  import BaseBtn from '@/ui/base/BaseBtn.svelte';

  import BasePill from './BasePill.svelte';

  export type Variant = 'suggestion' | 'delete';

  export interface ImprovementProps {
    key: string;
    suggestion: string;
    variant: Variant;
    useAi?: boolean;
    onclick?: (key: string) => void;
  }
</script>

<script lang="ts">
  let { variant: variantProp = 'suggestion', ...props }: ImprovementProps = $props();

  const styles = tv({
    base: '',
    variants: {
      variant: {
        suggestion: 'bg-brandfit-suggestion',
        delete: 'bg-brandfit-delete',
      },
    },
  });
</script>

<BaseBtn
  class="w-fit"
  onclick={() => {
    props.onclick?.(props.key);
  }}
>
  <BasePill class={styles({ variant: variantProp })}>
    {props.suggestion}
    {#if props.useAi}
      <Icon icon="AutoAwesome" size={4} class="ml-1 inline align-bottom" />
    {/if}
  </BasePill>
</BaseBtn>
